import { createAction } from '@ngrx/store';
export const resetAllCustomPdfReportItems = createAction('[Custom PDF Report Modal] Reset all Custom PDF Report Items');
